import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Utils from '../../../Services/Utils';

import { FormContext } from '../../../Context/FormContext';
import Radio from '../Radio';

import './style.scss';
import ConfigService from '../../../Services/api/Config';

class RadioWrapper extends React.PureComponent {
  static contextType = FormContext;

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) {
      onError(newError);
    }
  };

  validate = (value) => {
    const { required, validators } = this.props;
    if (required && Utils.isEmpty(value)) {
      return 'This field is required.';
    }
    for (const validator of validators || []) {
      if (validator(value)) {
        return validator(value);
      }
    }
    return '';
  };

  handleChange = (value) => {
    const { onChange, onError, error, name } = this.props;
    const val = this.props.value === value ? null : value;
    if (onChange) {
      onChange(name, val);
    }
    const newError = this.validate(val);
    if (onError && !Utils.equals(newError, error)) {
      onError(newError);
    }
  };

  render() {
    const { label, error, className, required, options, disabled, compact, value, name } = this.props;

    const isSubmitted = this.context ? this.context.isSubmitted : false;
    return (
      <div
        className={classNames(className, 'InputWrapper', {
          InputWrapper_Error: Boolean(error) && Boolean(isSubmitted)
        })}>
        {label && (
          <div className="InputWrapper-Label">
            {label}
            {required && (
              <span className="InputWrapper-Label-Required" style={{ color: ConfigService.getColor('errorColor') }}>
                *
              </span>
            )}
          </div>
        )}
        <div className="InputWrapper-Content">
          {options.map((item, index) => {
            return (
              <Radio
                key={index}
                onChange={() => this.handleChange(item.value)}
                value={item.value}
                label={item.label}
                checked={value === item.value}
                disabled={disabled}
                compact={compact}
                help={item.help}
                name={name + index + ''}
                className={className}
              />
            );
          })}
        </div>
        {error && isSubmitted && (
          <div className="InputWrapper-Error" style={{ color: ConfigService.getColor('errorColor') }}>
            {error}
          </div>
        )}
      </div>
    );
  }
}

RadioWrapper.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  error: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  // compact: PropTypes.bool,
  isSubmitted: PropTypes.bool
};

export default RadioWrapper;
